import { Component, input } from '@angular/core';
import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '@shared/components/challenges/elements';
import { CampaignPhase } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeFourthVariantConfig } from '@shared/models';
import { TransformUrlToBgPipe, VariableReplacementPipe } from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant4',
  styleUrl: './variant4.component.scss',
  templateUrl: './variant4.component.html',
  imports: [
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant4Component extends FrequencyBaseClass {
  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeFourthVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
